var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlanned(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.829,
    height: 21.334,
    viewBox: "0 0 19.829 21.334",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2738",
    "data-name": "Group 2738",
    transform: "translate(-20231.45 -9645.832)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4066",
    "data-name": "Path 4066",
    d: "M146.712,40.706h-2.485v-1a.5.5,0,0,0-1,0v1h-9.788v-1a.5.5,0,1,0-1,0v1H130.7a1.963,1.963,0,0,0-1.907,2.008V58.526a1.963,1.963,0,0,0,1.907,2.008h16.013a1.963,1.963,0,0,0,1.907-2.008V42.714a1.963,1.963,0,0,0-1.907-2.008Zm.9,17.82h0a.959.959,0,0,1-.9,1H130.7a.959.959,0,0,1-.9-1v-12.8h17.82Zm0-13.8H129.8V42.714a.959.959,0,0,1,.9-1h1.732v1.255a.5.5,0,0,0,1,0V41.71h9.788v1.255a.5.5,0,0,0,1,0V41.71h2.485a.959.959,0,0,1,.9,1Z",
    transform: "translate(20102.658 9606.632)",
    fill: "#00dab6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4068",
    "data-name": "Path 4068",
    d: "M184.675,234.143a1.27,1.27,0,0,0,1.017.635h.089a1.27,1.27,0,0,0,1.01-.5l6.353-8.26a1.273,1.273,0,0,0-2.02-1.55l-5.184,6.747-1.595-2.8a1.275,1.275,0,1,0-2.211,1.271Z",
    transform: "translate(20053.678 9429.632)",
    fill: "#00dab6"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanned);
export default __webpack_public_path__ + "static/media/planned.4f2123050d918ce3ee3d4c98a8415414.svg";
export { ForwardRef as ReactComponent };